import { GREETING_DESKTOP, vipHeading } from '@/constants/content'
import useBootstrapData from '@/hooks/useBootstrapData'
import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import useClientSideSignedInData from '@/hooks/useClientSideSignedInData'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import type { LOCATION_SEARCH_TYPE } from '@/types'
import { useState } from 'react'
import type { SearchFormProductHeadlineType } from '../types'

export default function useFormatHotelHeadline(values: SearchFormProductHeadlineType) {
  const {
    customer: { firstName: bootstrapFirstName },
    signInStatus: { signedIn: serverSideSignedIn },
  } = useBootstrapData()

  const { firstName: clientSideFirstName, signedIn: clientSideSignedIn } = useClientSideSignedInData()

  const firstName = serverSideSignedIn
    ? bootstrapFirstName
    : clientSideSignedIn
      ? clientSideFirstName
      : undefined

  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()

  const SEMHeadline = useSEMSearchHeadline()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const headlineWithName = firstName ? vipHeading.headlineWithName(firstName) : GREETING_DESKTOP
  const defaultHeadline = firstName ? headlineWithName : values.hotels.headline
  const hotelHeadline = prePopHeadline || SEMHeadline || defaultHeadline
  return { hotelHeadline, setLocation, clientSideFirstName }
}
